import { nanoid } from 'nanoid';
import { supabase } from '../lib/supabase';

export const generateVerificationCode = () => {
  // Generate a 6-digit code
  return Math.floor(100000 + Math.random() * 900000).toString();
};

export const generateVerificationToken = () => {
  // Generate a unique token for magic link
  return nanoid(32);
};

// 存储验证码到Supabase
const storeVerificationCode = async (email: string, code: string) => {
  const expires_at = new Date();
  expires_at.setMinutes(expires_at.getMinutes() + 15); // 15分钟过期

  const { error } = await supabase
    .from('email_verification_codes')
    .insert({
      email,
      code,
      expires_at,
      used: false
    });

  if (error) throw error;
};

export const sendLoginEmail = async (email: string) => {
  try {
    // 发送登录链接
    const { error } = await supabase.auth.signInWithOtp({
      email,
      options: {
        emailRedirectTo: `${window.location.origin}/verify-login`,
      }
    });

    if (error) {
      throw error;
    }
    
    return { success: true };
  } catch (error) {
    console.error('Failed to send verification email:', error);
    throw error;
  }
};

export const verifyOTP = async (email: string, token: string) => {
  try {
    const { data, error } = await supabase.auth.verifyOtp({
      email,
      token,
      type: 'email'
    });

    if (error) {
      console.error('Verification error:', error);
      return false;
    }

    return !!data.user;
  } catch (error) {
    console.error('Verification error:', error);
    return false;
  }
};

// 生成随机密码
const generateRandomPassword = () => {
  const length = 16;
  const charset = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()_+';
  let password = '';
  for (let i = 0; i < length; i++) {
    password += charset.charAt(Math.floor(Math.random() * charset.length));
  }
  return password;
}; 